export const tabHeader2 = [
  { key: "1", label: "Регіон", width: "initial" },
  { key: "2", label: "100% Потреба", width: "initial" },
  { key: "3", label: "100% потреба профінансовано", width: "initial" },
  { key: "4", label: "Залишки", width: "initial" },
  { key: "5", label: "Початкова забезпеченість", width: "initial" },
  { key: "6", label: "Забезпеченість після розподілу", width: "initial" },
  { key: "7", label: "Розподілена кількість", width: "initial" },
  { key: "8", label: "", width: "initial" },
];

export const mnnTabHeader2 = [
  { key: "1", label: "МНН" },
  { key: "2", label: "МНН ID" },
  { key: "3", label: "Залишок у запасі" },
  { key: "4", label: "Ціна" },
  { key: "5", label: "Кратність" },
  { key: "6", label: "Перевірено" },
  { key: "7", label: "" },
];

export const attachmentsTabHeader2 = [
  { key: "1", label: "Тип" },
  { key: "2", label: "Файл" },
  { key: "3", label: "Номер" },
  { key: "4", label: "Дата" },
  { key: "5", label: "Завантаження здійснив" },
  { key: "6", label: "" },
];

export const componentsTabHeader = [
  { key: "1", label: "Назва" },
  { key: "2", label: "Термін придатності" },
  { key: "3", label: "Кількість" },
  { key: "4", label: "Каталожний номер" },
];

export const datesTabHeader2 = [
  { key: "1", label: "МНН" },
  { key: "2", label: "МНН ID" },
  { key: "3", label: "Контрольна дата" },
];
